<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>0546-8018079
          <span class="glyphicon glyphicon-envelope"></span>dyjmhx@163.com
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/jm/jm-gw-logo3.png">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item, index) in navList.slice(0, 6)" :key="index" :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item.name)">
          <router-link :to="item.path">
            {{ item.name }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
<!--            <i class="underline"></i>-->
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
        <li>
          <a href="https://dycjhx.com/jmweb/" target="_blank" class="no-underline-newtab">招采平台</a>
<!--          <i class="underline"></i>-->
        </li>
        <li>
          <a class="no-underline-newtab">
            <span>客商平台</span>
<!--            <span class="glyphicon glyphicon-menu-down"></span>-->
          </a>
          <dl>
            <dt>
              <a href="https://www.dyjmly.top:8082/pcshop/" target="_blank" class="no-underline-newtab">客商登录</a>
            </dt>
            <dt>
              <a href="https://www.dyjmly.top:8082/pcshop/#/carrierLogin " target="_blank" class="no-underline-newtab">承运商登录</a>
            </dt>
          </dl>
        </li>
        <li v-for="(item, index) in navList.slice(-1)" :key="6" :class="6 == navIndex ? 'active' : ''"
            @click="navClick(6, item.name)">
          <router-link :to="item.path">
            {{ item.name }}
            <span v-if="item.children.length > 0" class="glyphicon glyphicon-menu-down"></span>
<!--            <i class="underline"></i>-->
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/jm/jm-m-logo1.png" alt="logo">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item, index) in navList" :key="index" :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "公司概况",
          path: "/companyintroduction",
          children: []
        },
        {
          name: "新闻动态",
          path: "/newsinformation",
          children: []
        },
        {
          name: "产品中心",
          path: "/software",
          children: []
        },
        {
          name: "工会风采",
          path: "/service",
          children: []
        },
        {
          name: "人才招聘",
          path: "/jobchance",
          children: []
        },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex', index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  /*background: #f4f4f4;*/
  transition: all ease 0.6s;
}

#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 110px;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 430px;
  height: 100%;
  float: left;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 430px;
  height: 90px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 840px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper>li {
  float: left;
  margin: 0 15px;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper>li>a {
  color: #000;
  font-size: 28px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
  outline: none;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper>li>a>i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper>li>a>span {
  font-size: 12px;
  font-weight: bold;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover {
  color: #1e73be;
  text-decoration: none;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper>li>a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper li.active>a {
  /*color: #1e73be;*/
  color: #0662B1;
  text-decoration: none;
  /*border-bottom: 2px solid #1e73be;*/
  /*border-bottom: 2px solid #0662B1;*/
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper>li>dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper>li>dl>dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper>li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
  cursor: pointer;
  /*background: #ccc;*/
  background: #ccc;
}

/* 跳转后的状态（无下划线） */
.no-underline-newtab {
  text-decoration: none !important;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 90px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 105px;
    height: 90px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper>li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper>li>a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 10px;
  }
}

@media (min-width: 768px) {
  /* 导航栏logo */
  #header .header-nav .header-nav-logo {
    width: 200px;
  }
  /* 导航栏logo图片 */
  #header .header-nav .header-nav-logo img {
    width: 200px;
    height: 60px;
  }
  #header .header-nav .header-nav-wrapper {
    max-width: 520px;
  }
  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper li {
    margin: 0 2px;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper li>a {
    font-size: 14px;
  }
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 14px;
  }
  #header .header-nav .header-nav-wrapper>li>dl {
    font-size: 12px;
  }
}
@media (min-width: 992px) {
  /* 导航栏logo */
  #header .header-nav .header-nav-logo {
    width: 260px;
  }
  /* 导航栏logo图片 */
  #header .header-nav .header-nav-logo img {
    width: 260px;
    height: 66px;
  }
  #header .header-nav .header-nav-wrapper {
    max-width: 700px;
  }
  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper li {
    margin: 0 3px;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper li>a {
    font-size: 18px;
  }
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 18px;
  }
  #header .header-nav .header-nav-wrapper>li>dl {
    font-size: 14px;
  }
}
@media (min-width: 1200px) {
  /* 导航栏logo */
  #header .header-nav .header-nav-logo {
    width: 290px;
  }
  /* 导航栏logo图片 */
  #header .header-nav .header-nav-logo img {
    width: 290px;
    height: 70px;
  }
  #header .header-nav .header-nav-wrapper {
    max-width: 840px;
  }
  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper li {
    margin: 0 5px;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper li>a {
    font-size: 22px;
  }
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 22px;
  }
  #header .header-nav .header-nav-wrapper>li>dl {
    font-size: 18px;
  }
}
@media (min-width:1400px){
  .container{
    width:1370px
  }
  /* 导航栏logo */
  #header .header-nav .header-nav-logo {
    width: 350px;
  }
  /* 导航栏logo图片 */
  #header .header-nav .header-nav-logo img {
    width: 350px;
    height: 80px;
  }
  #header .header-nav .header-nav-wrapper {
    max-width: 980px;
  }
  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper li {
    margin: 0 5px;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper li>a {
    font-size: 25px;
  }
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 25px;
  }
  #header .header-nav .header-nav-wrapper>li>dl {
    font-size: 21px;
  }
}
@media (min-width:1920px){
  .container{
    width:1700px
  }
  /* 导航栏logo */
  #header .header-nav .header-nav-logo {
    width: 450px;
  }
  /* 导航栏logo图片 */
  #header .header-nav .header-nav-logo img {
    width: 450px;
    height: 90px;
  }
  #header .header-nav .header-nav-wrapper {
    max-width: 1200px;
  }
  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper li {
    margin: 0 10px;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper li>a {
    font-size: 28px;
  }
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 28px;
  }
  #header .header-nav .header-nav-wrapper>li>dl {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue